import React from "react";
import { Container } from "react-bootstrap";
import "./VehicleIntroBannerSection.css";
import { useTranslation } from "react-i18next";

export default function VehicleIntroBannerSection({ vehicle }) {
  const { t } = useTranslation();

  const {
    detailIntroBanner,

    // ✅ Recommended keys (translation-driven)
    detailIntroTitleKey,
    detailIntroParagraph1Key,
    detailIntroParagraph2Key,

    // ✅ Fallbacks (if old data still exists)
    detailIntroTitle,
    detailIntroParagraph1,
    detailIntroParagraph2,
  } = vehicle;

  const title = detailIntroTitleKey ? t(detailIntroTitleKey) : detailIntroTitle || "";
  const p1 = detailIntroParagraph1Key ? t(detailIntroParagraph1Key) : detailIntroParagraph1 || "";
  const p2 = detailIntroParagraph2Key ? t(detailIntroParagraph2Key) : detailIntroParagraph2 || "";

  return (
    <section
      className="vehicle-intro-banner section-spacing"
      style={
        detailIntroBanner
          ? {
            backgroundImage: `linear-gradient(
                120deg,
                rgba(0, 0, 0, 0.78),
                rgba(0, 0, 0, 0.45)
              ), url(${detailIntroBanner})`,
          }
          : undefined
      }
    >
      <Container fluid>
        <div className="vehicle-intro-banner__content">
          {title && <h2 className="vehicle-intro-banner__title">{title}</h2>}

          {p1 && <p className="vehicle-intro-banner__paragraph">{p1}</p>}

          {p2 && <p className="vehicle-intro-banner__paragraph">{p2}</p>}
        </div>
      </Container>
    </section>
  );
}